(function () {
  const COPERTA_VARIANT = 56888237982074;
  const BUNDLE2_VARIANT = 56903340458362;
  const GIFT_VARIANTS = [56936106754426, 56936104984954];
  let isSyncing = false;

  async function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
  }

  function getCartSectionId() {
    const el = document.getElementById('main-cart-items');
    return el ? el.dataset.id : null;
  }

  function rerenderCart(sections, sectionId) {
    const cartItemsEl = document.getElementById('main-cart-items');
    if (!cartItemsEl || !sections || !sections[sectionId]) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(sections[sectionId], 'text/html');
    const newContent = doc.querySelector('.js-contents');
    const currentContent = cartItemsEl.querySelector('.js-contents');
    if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;
  }

  async function syncGifts() {
    if (isSyncing) return;
    isSyncing = true;
    try {
      const cart = await getCart();
      const coperta = cart.items.find(i => i.variant_id === COPERTA_VARIANT);
      const bundle2 = cart.items.find(i => i.variant_id === BUNDLE2_VARIANT);
      const targetQty = (coperta ? coperta.quantity : 0) + (bundle2 ? bundle2.quantity * 2 : 0);

      const updates = {};
      let needsUpdate = false;
      for (const giftId of GIFT_VARIANTS) {
        const giftItem = cart.items.find(i => i.variant_id === giftId);
        if (!giftItem) continue;
        if (giftItem.quantity !== targetQty) {
          updates[giftId] = targetQty;
          needsUpdate = true;
        }
      }

      if (!needsUpdate) return;

      const sectionId = getCartSectionId();
      const body = { updates };
      if (sectionId) {
        body.sections = [sectionId, 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(r => r.json());

      if (response.sections && sectionId) {
        rerenderCart(response.sections, sectionId);
        // Update cart bubble
        if (response.sections['cart-icon-bubble']) {
          document.querySelectorAll('#cart-icon-bubble').forEach(el => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');
            const newBubble = doc.querySelector('.shopify-section');
            if (newBubble) el.innerHTML = newBubble.innerHTML;
          });
        }
      } else {
        window.location.reload();
      }
    } finally {
      isSyncing = false;
    }
  }

  function trySubscribePubSub() {
    if (window.subscribe) {
      window.subscribe('cart-update', () => { if (!isSyncing) setTimeout(syncGifts, 200); });
    } else {
      setTimeout(trySubscribePubSub, 200);
    }
  }
  trySubscribePubSub();

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = (args[0] || '').toString();
    if (!isSyncing && (url.includes('/cart/change') || url.includes('/cart/add'))) {
      setTimeout(syncGifts, 350);
    }
    return response;
  };

  document.addEventListener('DOMContentLoaded', syncGifts);
})();

